export const SET_EXPLORE_MODAL = 'SET_EXPLORE_MODAL';
export const SET_IS_SHOW_EXPLORE_MODAL = 'SET_IS_SHOW_EXPLORE_MODAL';
export const SET_IS_SHOW_CENTER_EXPLORE_MODAL = 'SET_IS_SHOW_CENTER_EXPLORE_MODAL';
export const SET_IS_EXPLORE_AMENITIES = 'SET_IS_EXPLORE_AMENITIES'
